
import dialogDashboard from "@/views/dashboard/top/dialog/dialog.vue";
import VueApexCharts from "vue-apexcharts";
import {
    getOverview,
    getTopreport,
    getStudentReportUsergroup
} from "@/service/dashboard/dashboard";
export default {
    props: {
        sendTopreport: {
            type: Object,
        },
        dataGroupSelect: {
            type: Array,
        },
        dataIsGroupNull: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        apexchart: VueApexCharts,
        dialogDashboard,
    },
    mounted() {
        this.initialize();
    },
    dataGroupSelect(value) {
        this.dataGroup = value
        this.setTimeDashboardDaily(this.dataParams.starttime, this.dataParams.endtime)
    },
    data() {
        return {
            loaddata: false,
            main_data: {
                allCourse: 0,
                allStudent: 0,
                onlineCourseToday: 0,
                allMedia: 0,
                arrayMedia: {
                    video: 0,
                    pdf: 0,
                    exam: 0,
                    book: 0,
                    file: 0,
                    image: 0,
                    blog: 0,
                    url: 0,
                    youtube: 0,
                },
                arraySkill: []
            },
            sendDataGroupSelect: [],
            dataGroup: [],
            arraySkillNew: [],
            topBuyCourse: [],
            topUserViewCourse: [],
            topViewLive: [],
            deviceSeries: [20, 20, 20],
            userSeries: [20, 20, 20],
            deviceChartOptions: {

                chart: {

                    type: 'pie'
                },
                legend: {
                    show: true,
                    fontSize: '20px',
                    fontWeight: 400,
                    // formatter: function (val, opts) {
                    //     return val + "  " + opts.w.globals.series[opts.seriesIndex]
                    // }
                },
                labels: ['Web App', 'IOS', 'Android'],
                colors: ['#90A4AE', '#4FC3F7', '#81C784',],
                responsive: [{
                    breakpoint: 480,
                    options: {

                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'top'
                        }
                    }
                }],

            },
            usersChartOptions: {

                chart: {

                    type: 'pie'
                },
                legend: {
                    show: true,
                    fontSize: '20px',
                    fontWeight: 400,
                    // formatter: function (val, opts) {
                    //     return val + "  " + opts.w.globals.series[opts.seriesIndex]
                    // }
                },
                labels: ['ยังไม่เคยใช้งาน', 'เคยเข้าเรียนแล้ว', 'เข้าสู่ระบบอย่างเดียว'],
                colors: ['#F06292', '#64B5F6', '#FFD54F'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            isOpenTopUserView: false,
            isOpenBuyUser: false,
            isOpenViewLive: false,
            userAll: 0,
            userLogin: 0,

        }
    },
    watch: {
        sendTopreport(value) {
            this.sendTopreport = value
            this.initialize()
        },
        dataGroupSelect(value) {
            this.dataGroup = value
            console.log("top", this.dataGroup)
            this.sendDataGroupSelect = value
            this.selectionGroup()
        },
    },
    methods: {
        async initialize() {
            this.loaddata = true
            let results = await getStudentReportUsergroup({ usergroup: this.dataGroup, groupnull: this.dataIsGroupNull })

            this.userSeries = []
            if (results) {

                this.userAll = results.userAll;
                this.userLogin = results.userLogin;
                this.userSeries.push(results.noLogin)
                this.userSeries.push(results.resultLearn)
                this.userSeries.push(results.loginNotLearn)
            }
            this.main_data = {
                allCourse: 0,
                allStudent: 0,
                onlineCourseToday: 0,
                allMedia: 0,
                arrayMedia: {
                    video: 0,
                    pdf: 0,
                    exam: 0,
                    book: 0,
                    file: 0,
                    image: 0,
                    blog: 0,
                    url: 0,
                    youtube: 0,
                },
                arraySkill: []
            }
            let result = this.sendTopreport.resultTopreport;
            this.dataTop = result
            let topViewLive = []
            let topBuyCourse = []
            let topUserViewCourse = []
            for (let index = 0; index < 5; index++) {
                if (result) {
                    if (result.topViewLive[index]) {
                        topViewLive.push(result.topViewLive[index])
                    } else {
                        topViewLive.push({})
                    }
                    if (result.topBuyCourse[index]) {
                        topBuyCourse.push(result.topBuyCourse[index])
                    } else {
                        topBuyCourse.push({})
                    }
                    if (result.topUserViewCourse[index]) {
                        topUserViewCourse.push(result.topUserViewCourse[index])
                    } else {
                        topUserViewCourse.push({ firstName: '', lastName: '' })
                    }
                }

            }
            this.topViewLive = topViewLive
            this.topBuyCourse = topBuyCourse
            this.topUserViewCourse = topUserViewCourse
            let resultOverview = this.sendTopreport.resultOverview;
            this.deviceSeries = []
            if (resultOverview) {
                this.deviceSeries.push(resultOverview.countDevice.web)
                this.deviceSeries.push(resultOverview.countDevice.ios)
                this.deviceSeries.push(resultOverview.countDevice.android)

            }
            this.loaddata = resultOverview ? false : true
            this.main_data = resultOverview
        },
        async selectionGroup() {
            this.loaddata = true
            this.main_data = {
                allCourse: 0,
                allStudent: 0,
                onlineCourseToday: 0,
                allMedia: 0,
                arrayMedia: {
                    video: 0,
                    pdf: 0,
                    exam: 0,
                    book: 0,
                    file: 0,
                    image: 0,
                    blog: 0,
                    url: 0,
                    youtube: 0,
                },
                arraySkill: []
            }
            let datenow = new Date((new Date()).setHours(0, 0, 0, 0))
            let dataParams = {
                starttime: (new Date(datenow - (24 * 60 * 60 * 1000 * 6))).setHours(0, 0, 0, 0),
                endtime: datenow.getTime(),
                usergroup: this.dataGroupSelect,
                groupnull: this.dataIsGroupNull,
            }
            let resultOverview = await getOverview(dataParams)
            let resultTopreport = await getTopreport(dataParams)
            let results = await getStudentReportUsergroup({ usergroup: this.dataGroup, groupnull: this.dataIsGroupNull })
            this.userSeries = []
            if (results) {
                this.userAll = results.userAll;
                this.userLogin = results.userLogin;
                this.userSeries.push(results.noLogin)
                this.userSeries.push(results.resultLearn)
                this.userSeries.push(results.loginNotLearn)
            }
            let result = resultTopreport;
            this.dataTop = result
            let topViewLive = []
            let topBuyCourse = []
            let topUserViewCourse = []
            for (let index = 0; index < 5; index++) {
                if (result) {
                    if (result.topViewLive[index]) {
                        topViewLive.push(result.topViewLive[index])
                    } else {
                        topViewLive.push({})
                    }
                    if (result.topBuyCourse[index]) {
                        topBuyCourse.push(result.topBuyCourse[index])
                    } else {
                        topBuyCourse.push({})
                    }
                    if (result.topUserViewCourse[index]) {
                        topUserViewCourse.push(result.topUserViewCourse[index])
                    } else {
                        topUserViewCourse.push({ firstName: '', lastName: '' })
                    }
                }

            }
            this.topViewLive = topViewLive
            this.topBuyCourse = topBuyCourse
            this.topUserViewCourse = topUserViewCourse

            this.deviceSeries = []
            if (resultOverview) {
                this.deviceSeries.push(resultOverview.countDevice.web)
                this.deviceSeries.push(resultOverview.countDevice.ios)
                this.deviceSeries.push(resultOverview.countDevice.android)

            }
            this.loaddata = resultOverview ? false : true
            this.main_data = resultOverview
        },
        openDialogTopUserView() {
            this.isOpenTopUserView = true
        },
        closeDialogTopUserView() {
            this.isOpenTopUserView = false
        },
        openDialogTopBuyUser() {
            console.log("open")
            this.isOpenBuyUser = true
        },
        closeDialogBuyUser() {
            this.isOpenBuyUser = false
        },
        openDialogTopViewLive() {
            console.log("open")
            this.isOpenViewLive = true
        },
        closeDialogViewLive() {
            this.isOpenViewLive = false
        },
    }
}